import React from 'react';
import GridShape from '@shared/components/GridShape';
import { Link, Outlet } from 'react-router-dom';
import { ThemeToggleButton } from '@shared/components/ThemeToggleButton';
import MotorPlanLogo from '@shared/components/MotorPlanLogo';

interface AuthLayoutProps {
  children?: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="relative p-6 bg-mp-surface z-1 sm:p-0">
      <div className="relative flex flex-col justify-center w-full h-[calc(100vh-var(--env-banner-height))] lg:flex-row sm:p-0">
        <div className="flex flex-col w-full lg:h-full lg:w-1/2 lg:grid lg:items-center">
          {/* Brand logo on the white panel for < lg, where the right-hand
                        brand panel is hidden. Forced to the `colour` (navy + teal)
                        lockup: this panel reads as white/branded, so the on-white
                        lockup is correct regardless of theme. Sized by width.
                        Column height is content-based below lg so the outer
                        `justify-center` centres the logo + form together; `lg:h-full`
                        + `lg:items-center` restore the grid-centred form when the
                        side panel returns. `items-center` is gated to lg so the form
                        keeps its full-width flow (and its own max-w-md) below lg;
                        the logo self-centres instead. */}
          <Link to="/" className="self-center block mb-8 lg:hidden">
            <MotorPlanLogo textSize="w-72 sm:w-96 md:w-[28rem]" variant="colour" />
          </Link>
          {children || <Outlet />}
        </div>
        <div className="items-center hidden w-full h-full lg:w-1/2 bg-mp-midnight-navy lg:grid">
          <div className="relative flex items-center justify-center z-1">
            {/* <!-- ===== Common Grid Shape Start ===== --> */}
            <GridShape />
            <div className="flex flex-col items-center w-full max-w-md px-8">
              <Link to="/" className="block w-full mb-6 text-mp-primary">
                {/* Sized by width: the 7.18:1 lockup fills the column, height
                                    follows the viewBox. Tune the wrapper max-w-* to resize. */}
                <MotorPlanLogo textSize="w-full" variant="reverse" />
              </Link>
              <h2 className="text-center text-2xl font-normal text-mp-midnight-navy-foreground/60">
                Servicing made easy.
              </h2>
            </div>
          </div>
        </div>
        <div className="fixed z-50 hidden bottom-6 right-6 sm:block">
          <ThemeToggleButton variant="solid" />
        </div>
      </div>
    </div>
  );
};
